const uuid = require('uuid');

module.exports = (logger) => (application, hideBody) => (req, res, next) => {
    res.header('x-request-id', uuid());
    req.start = Date.now();

    function logRequest() {
        let parsedBody;

        if (hideBody) {
            parsedBody = 'hidden';
        } else {
            try {
                parsedBody = req.body && JSON.stringify(req.body);
            } catch (e) {
                parsedBody = req.body;
            }
        }

        const requestData = {
            'accept-language': res.get('Accept-Language'),
            'content-length': res.get('content-length'),
            method: req.method,
            /* eslint-disable no-underscore-dangle */
            'remote-addr':
          req.get('X-Forwarded-For')
          || req.ip
          || req._remoteAddress
          || (req.connection && req.connection.remoteAddress)
          || undefined,
            /* eslint-enable no-underscore-dangle */
            'request-id': res.get('x-request-id'),
            'response-time': parseFloat(Date.now() - req.start),
            status: res.statusCode,
            url: req.url,
            body: parsedBody,
            application
        };

        logger.info('', requestData);
    }

    res.on('finish', logRequest);
    res.on('close', logRequest);

    next();
};
